module.exports = __webpack_public_path__ + "img/pr-3.c23c9162.png";